import React, { useEffect } from 'react';
import { Pagination as BasePagination } from '../../../../Pagination/Pagination';
import { useDataTableContext } from '../../context/DataTableContext';
import { styled } from '../../../../../styles';

export const Pagination: React.FC = () => {
  const { pageModel, actions, tableInstance, state } = useDataTableContext();
  const [localPageIndex, setLocalPageIndex] = React.useState(pageModel.currentPage + 1);

  useEffect(() => {
    setLocalPageIndex(pageModel.currentPage + 1);
  }, [pageModel.currentPage]);

  return (
    <StyledBasePagination
      count={tableInstance.getPageCount()}
      shape="rounded"
      showFirstButton
      showLastButton
      $readOnly={state.loading}
      page={localPageIndex}
      onChange={(_, nextPageIndex) => {
        setLocalPageIndex(nextPageIndex);
        actions.setPageNumber(nextPageIndex - 1);
      }}
    />
  );
};

const StyledBasePagination = styled(BasePagination)<{ $readOnly: boolean }>`
    pointer-events: ${({ $readOnly }) => ($readOnly ? 'none' : undefined)};
`;
